import React, { createContext, useContext, useState } from 'react';
import { translations } from '../config/translations';

const LanguageContext = createContext();
export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('wbla_lang') || 'gr');
  const t = (key) => translations[language][key] || key;
  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'gr' : 'en';
    setLanguage(newLang);
    localStorage.setItem('wbla_lang', newLang);
  };
  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
